import { LazyFragmentData, RecommendationPayload, RecommendationRequest } from "../types/fragment";
import { initRecommendationRoot } from "./lazy-loader";
import { reRenderRecommendationRoot } from "./reloader";

export function fetchRecommendations(
  reqData: LazyFragmentData,
  recoReqData: RecommendationRequest,
  isInitialLoad: boolean
) {
  const reqConfigId = reqData.useDefaultId ? reqData.defaultConfigId : reqData.customConfigId;
  const request = new Request(`${reqData.apiUrl}recommendations/${reqConfigId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(recoReqData)
  });

  fetch(request)
    .then((response) => {
      if (!response.ok) throw new Error(`Network response was not ok for id: ${reqConfigId}`);
      return response.json();
    })
    .then((response: RecommendationPayload) => {
      if (response.recommendations?.length > 0 && response.currencyInformation) {
        isInitialLoad
          ? initRecommendationRoot(response, reqData, recoReqData, isInitialLoad)
          : reRenderRecommendationRoot(response, reqData);
      } else {
        reqData.container.classList.add("hide-empty-container");
        throw new Error(`No recommendation articles available for id: ${reqConfigId}`);
      }
    })
    .catch((error) => {
      if (error instanceof Error) {
        console.warn(error.message);
      }
    });
}
